import { render, staticRenderFns } from "./customerStockList.vue?vue&type=template&id=2b747f04&"
import script from "./customerStockList.vue?vue&type=script&lang=ts&"
export * from "./customerStockList.vue?vue&type=script&lang=ts&"
import style0 from "./customerStockList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports